import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { POST, PAGE_LIMIT } from "helpers/viewContent";
import { DATE_FORMAT_TIME } from "helpers/common";
import ReactPagination from "components/shared/ReactPagination";
import { DELETE_ALERT } from "helpers/constantsMessage";
import { PRODUCT_IMG } from "utils/constant";
import ContentLoader_ from "helpers/ContentLoader_";
//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import {
  getList_,
  deleteData_,
  updateData_,
} from "store/services/commonService";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

const Listing = ({ dispatch, itemsCountPerPage, totalItemsCount, loader }) => {
  //pagination
  const [activePage, setActivePage] = useState(1);
  const [listing, setListing] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const history = useHistory();

  const fetchData = async () => {
    try {
      let query = {
        url: "post/list",
        page: activePage,
        limit: PAGE_LIMIT,
        post_type: tabIndex,
        common: false,
        search_string: searchValue,
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: false }));
      let res = await dispatch(getList_(query));
      setListing(res?.body?.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activePage, searchValue, tabIndex]);

  //pagination
  const handlePageChange = (page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };

  //delete
  const deleteDataFunction_ = async (id) => {
    try {
      await DELETE_ALERT().then(async (willDelete) => {
        if (willDelete) {
          try {
            let query = {
              url: "post/delete",
              id: id,
            };
            await dispatch(deleteData_(query)).then(() => {
              fetchData();
            });
          } catch (err) {
            console.log(err);
          }
        }
      });
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
    }
  };
  //update status
  const updateStatus_ = async (data) => {
    try {
      let query = {
        url: `post/update_status`,
        id: data?.id,
        status: data?.status === "1" ? "0" : "1",
      };
      await dispatch(updateData_(query));
      fetchData();
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <Helmet title={POST.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-format-list-bulleted menu-icon"></i>
          </span>{" "}
          {POST.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.post}>{POST.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Listing
            </li>
          </ol>
        </nav>
      </div>
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          <Tab>Admin Posts</Tab>
          <Tab>User Posts</Tab>
        </TabList>
        <TabPanel>
          <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">
                    <div className="row">
                      <div className="col-md-4">Listing</div>
                      <div className="col-md-6"></div>
                      <div className="col-md-2">
                        <Link to={Path.post_add} title="Add">
                          <button
                            type="button"
                            class="btn btn-lg btn-gradient-primary"
                          >
                            {" "}
                            + Add
                          </button>
                        </Link>
                      </div>
                    </div>
                  </h4>
                  <div class="table-responsive actionSticky">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th> Added By </th>
                          <th> Media </th>
                          <th> Media Type </th>
                          <th> Category </th>
                          <th> Status </th>
                          <th> Created At </th>
                          <th> Action </th>
                        </tr>
                      </thead>
                      {isLoading ? (
                        <div className="loader-class">
                          <ContentLoader_ />
                        </div>
                      ) : (
                        <>
                          <tbody>
                            {listing.length > 0 &&
                              listing.map((list, i) => {
                                return (
                                  <tr key={i}>
                                    <td>
                                      {list?.user?.name
                                        ? list?.user?.name
                                        : "N/A"}
                                    </td>
                                    <td className="py-1">
                                      <a
                                        href={
                                          list?.thumb ? `${list?.media}` : "#"
                                        }
                                        target="_blank"
                                      >
                                        <img
                                          src={
                                            list?.thumb
                                              ? `${list?.thumb}`
                                              : PRODUCT_IMG
                                          }
                                          className="custom-img"
                                        />
                                      </a>
                                    </td>
                                    <td>
                                      {list?.category
                                        ? list?.category?.name
                                        : "N/A"}
                                    </td>
                                    <td>
                                      <label
                                        style={{ cursor: "pointer" }}
                                        className=""
                                      >
                                        {list?.media_type === "1"
                                          ? "Video"
                                          : "Image"}
                                      </label>
                                    </td>
                                    <td onClick={() => updateStatus_(list)}>
                                      <label
                                        style={{ cursor: "pointer" }}
                                        className={`badge badge-gradient-${list?.status == 1
                                            ? "success"
                                            : "danger"
                                          }`}
                                      >
                                        {list?.status == 1
                                          ? "Block"
                                          : "Unblock"}
                                      </label>
                                    </td>
                                    <td>
                                      {list?.created_at
                                        ? DATE_FORMAT_TIME(list?.created_at)
                                        : "N/A"}
                                    </td>
                                    <td>
                                      <Link
                                        to={`${Path.post_edit}/${list?.id}`}
                                      >
                                        <label
                                          class="btn btn-sm btn btn-gradient-warning"
                                          style={{ cursor: "pointer" }}
                                          title="Edit"
                                        >
                                          <i className="mdi mdi-grease-pencil"></i>
                                        </label>
                                      </Link>
                                      &nbsp;&nbsp;
                                      <Link to={`${Path.postview}/${list?.id}`}>
                                        <label
                                          className="btn btn-sm btn btn-gradient-info"
                                          style={{ cursor: "pointer" }}
                                          title="View"
                                        >
                                          <i className="mdi mdi-eye"></i>
                                        </label>
                                      </Link>
                                      &nbsp;&nbsp;
                                      <label
                                        className="btn btn-sm btn btn-gradient-danger"
                                        style={{ cursor: "pointer" }}
                                        title="Delete"
                                        onClick={() =>
                                          deleteDataFunction_(list?.id)
                                        }
                                      >
                                        <i className="mdi mdi-delete"></i>
                                      </label>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </>
                      )}
                    </table>
                  </div>
                  {listing.length > 0 && (
                    <div className="pagination-box-review">
                      <ReactPagination
                        activePage={activePage}
                        itemsCountPerPage={itemsCountPerPage}
                        totalItemsCount={totalItemsCount}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  )}
                  {!isLoading && listing.length == 0 && (
                    <div className="row">
                      <div className="col-md-6 pt-5">
                        <span>No data found...</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">
                    <div className="row">
                      <div className="col-md-4">Listing</div>
                      <div className="col-md-6"></div>
                    </div>
                  </h4>
                  <div class="table-responsive actionSticky">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th> Added By </th>
                          <th> Media </th>
                          <th> Category </th>
                          <th> Media Type </th>
                          <th> Status </th>
                          <th> Created At </th>
                          <th> Action </th>
                        </tr>
                      </thead>
                      {isLoading ? (
                        <div className="loader-class">
                          <ContentLoader_ />
                        </div>
                      ) : (
                        <>
                          <tbody>
                            {listing.length > 0 &&
                              listing.map((list, i) => {
                                return (
                                  <tr key={i}>
                                    <td
                                      className="cursor-pointer"
                                      title="View"
                                      onClick={() =>
                                        history.push(
                                          `${Path.userview}/${list?.user?.id}`
                                        )
                                      }
                                    >
                                      <b>
                                        {list?.user?.name
                                          ? list?.user?.name
                                          : "N/A"}
                                      </b>
                                    </td>
                                    <td className="py-1">
                                      <a
                                        href={
                                          list?.thumb ? `${list?.media}` : "#"
                                        }
                                        target="_blank"
                                      >
                                        <img
                                          src={
                                            list?.thumb
                                              ? `${list?.thumb}`
                                              : PRODUCT_IMG
                                          }
                                          className="custom-img"
                                        />
                                      </a>
                                    </td>
                                    <td>
                                      {list?.category
                                        ? list?.category?.name
                                        : "N/A"}
                                    </td>
                                    <td>
                                      <label
                                        style={{ cursor: "pointer" }}
                                        className=""
                                      >
                                        {list?.media_type === "1"
                                          ? "Video"
                                          : "Image"}
                                      </label>
                                    </td>
                                    <td onClick={() => updateStatus_(list)}>
                                      <label
                                        style={{ cursor: "pointer" }}
                                        className={`badge badge-gradient-${list?.status == 1
                                          ? "success"
                                          : "danger"
                                          }`}
                                      >
                                        {list?.status == 1
                                          ? "Block"
                                          : "Unblock"}
                                      </label>
                                    </td>
                                    <td>
                                      {list?.created_at
                                        ? DATE_FORMAT_TIME(list?.created_at)
                                        : "N/A"}
                                    </td>
                                    <td>
                                      <Link to={`${Path.postview}/${list?.id}`}>
                                        <label
                                          className="btn btn-sm btn btn-gradient-info"
                                          style={{ cursor: "pointer" }}
                                          title="View"
                                        >
                                          <i className="mdi mdi-eye"></i>
                                        </label>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </>
                      )}
                    </table>
                  </div>
                  {listing.length > 0 && (
                    <div className="pagination-box-review">
                      <ReactPagination
                        activePage={activePage}
                        itemsCountPerPage={itemsCountPerPage}
                        totalItemsCount={totalItemsCount}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  )}
                  {!isLoading && listing.length == 0 && (
                    <div className="row">
                      <div className="col-md-6 pt-5">
                        <span>No data found...</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    itemsCountPerPage: state.Common.itemsCountPerPage,
    totalItemsCount: state.Common.totalItemsCount,
    loader: state.Common.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
